const axios = require('axios');

class ILoveImg {
    constructor(public_key) {
        this.public_key = public_key;
        this.server = "";
        this.task = "";
        this.imagesUpload = [];
        this.token = "";
    }

    async authentification() {
        const authentification = await axios.post(
            `https://api.iloveimg.com/v1/auth`,
            {
                public_key: this.public_key
            }
        );
        this.token = authentification.data.token;
    }



    async start(tool) {

        await this.authentification();
        const start = await axios.get(
            `https://api.iloveimg.com/v1/start/${tool}`,
            {
                headers: {
                    Authorization: "Bearer " + this.token
                }
            }
        );

        this.server = start.data.server;
        this.task = start.data.task;
    }

    async upload(imageUrl, imageName) {
        const upload = await axios.post(
            `https://${this.server}/v1/upload`,
            {
                task: this.task,
                cloud_file: imageUrl
            },
            {
                headers: {
                    Authorization: "Bearer " + this.token
                }
            }
        );

        this.imagesUpload.push([upload.data.server_filename, imageName]);
    }


    async compress() {

        for (let index = 0; index < this.imagesUpload.length; index++) {
            await axios.post(
                `https://${this.server}/v1/process`,
                {
                    task: this.task,
                    tool: "compressimage",
                    files: [
                        {
                            server_filename: this.imagesUpload[index][0],
                            filename: this.imagesUpload[index][1],
                        }
                    ],
                    compression_level: "recommended"
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.token
                    }
                }
            );
        }
    }

    async imageToJpg() {

        for (let index = 0; index < this.imagesUpload.length; index++) {
            await axios.post(
                `https://${this.server}/v1/process`,
                {
                    task: this.task,
                    tool: "convertimage",
                    files: [
                        {
                            server_filename: this.imagesUpload[index][0],
                            filename: this.imagesUpload[index][1],
                        }
                    ],
                    to: "jpg"
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.token
                    }
                }
            );
        }
    }

    async rotate(degree) {

        for (let index = 0; index < this.imagesUpload.length; index++) {
            await axios.post(
                `https://${this.server}/v1/process`,
                {
                    task: this.task,
                    tool: "rotateimage",
                    files: [
                        {
                            server_filename: this.imagesUpload[index][0],
                            filename: this.imagesUpload[index][1],
                            rotate: degree
                        }
                    ],
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.token
                    }
                }
            );
        }
    }

    async resize(width, height, ratio) {

        for (let index = 0; index < this.imagesUpload.length; index++) {
            await axios.post(
                `https://${this.server}/v1/process`,
                {
                    task: this.task,
                    tool: "resizeimage",
                    files: [
                        {
                            server_filename: this.imagesUpload[index][0],
                            filename: this.imagesUpload[index][1],
                        }
                    ],
                    resize_mode: 'pixels',
                    pixels_width: width,
                    pixels_height: height,
                    maintain_ratio: ratio,
                    no_enlarge_if_smaller: 'false'
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.token
                    }
                }
            );
        }
    }

    async crop(x, y, width, height) {

        for (let index = 0; index < this.imagesUpload.length; index++) {
            await axios.post(
                `https://${this.server}/v1/process`,
                {
                    task: this.task,
                    tool: "cropimage",
                    files: [
                        {
                            server_filename: this.imagesUpload[index][0],
                            filename: this.imagesUpload[index][1],
                        }
                    ],
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.token
                    }
                }
            );
        }
    }

    async nextTask(nextTool) {

        const nextTask = await axios.post(
            `https://${this.server}/v1/task/next`,
            {
                task: this.task,
                tool: nextTool
            },
            {
                headers: {
                    Authorization: "Bearer " + this.token
                }
            }
        );
        this.imagesUpload = []
        this.task = nextTask.data.task;
        for (const key in nextTask.data.files) {
            this.imagesUpload.push([key, nextTask.data.files[key]]);
        }
    }

    async download() {
        const download = await axios.get(
            `https://${this.server}/v1/download/${this.task}`,
            {
                headers: {
                    Authorization: "Bearer " + this.token
                },
                responseType: "blob",
            }
        );
        return download.data;
    }

}

module.exports = { ILoveImg };
